import "./components/jquery";

import Rails from "@rails/ujs";
Rails.start();

import "@story/story_assets/utils";
import "@story/story_assets/dom_extend";
import "@story/story_assets/ajax";
import "@story/story_assets/snippets";
import "@story/story_assets/animations";
import "@story/story_assets/slide";

import { Modal } from "./components/modal";
import "../../../node_modules/@story/story_assets/app/assets/javascripts/modal/modal_dialog.js";

import "./components/modal_alert";
import "./components/nested_form_fields";
import "./components/attachments";
import "./components/datalist";
import "./components/autosave";
import "./components/increment";

;(function() {

	//
	// Opened modal inside nested form after its removation.
	//
	document.addEventListener("nestedformfieldsremoving", function(event) {
		var modals = event.detail.nestedFieldsContainer.querySelectorAll(".modal");
		for (var i = 0; i < modals.length; ++i) {
			Modal.get(modals[i]).close();
		}
	});

	document.addEventListener("nestedformfieldsadded", function(event) {
		event.detail.nestedFieldsContainer.trigger("input");
	});

	document.addEventListener("nestedformfieldsremoved", function(event) {
		event.detail.nestedFieldsContainer.trigger("input");
	});

	document.addEventListener("ajax:before", function(event) {
		event.target.classList.add("sending-request");
	});

	document.addEventListener("ajax:success", function (event) {
		document.trigger("ajaxsuccess", { responseJSON: event.detail[0] });
	});

	document.addEventListener("ajax:complete", function(event) {
		event.target.classList.remove("sending-request");
	});

	// document.addEventSelectorListener("click", "[href][data-ajax]", function (event, target) {
	// 	event.preventDefault();
	// 	var url = target.getAttribute("href");
	// 	Ajax.get(url);
	// });

	// function renumber(subcontainer) {
	// 	var container = subcontainer.closest(".nested-fields-renumbering");
	// 	if (!container) {
	// 		return;
	// 	}

	// 	var index = 0;
	// 	var fields = container.querySelectorChildren(".nested_fields");
	// 	for (var i = 0; i < fields.length; ++i) {
	// 		var field = fields[i];
	// 		if (!field.isVisible()) {
	// 			continue;
	// 		}

	// 		console.log(field);

	// 		++index;
	// 	}
	// }

	// document.addEventListener("nestedformfieldsremoved", function(event) {
	// 	renumber(event.detail.nestedFieldsContainer);
	// });

	// document.addEventListener("nestedformfieldsadded", function(event) {
	// 	renumber(event.detail.nestedFieldsContainer);
	// });


}());
